import { useEffect } from "react";

type UseBeforeUnloadOptions = {
  isEnabled: boolean;
};

/**
 * Shows the native browser confirmation dialog when the user attempts to leave the page
 * (via browser back, close tab, refresh, or navigating away).
 */
export function useBeforeUnload(options: UseBeforeUnloadOptions) {
  useEffect(() => {
    if (!options.isEnabled) return undefined;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();

      return false;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [options.isEnabled]);
}
